import { PhoneNumber as MyleModelsCommonResponsePhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { PhoneNumber } from "@/Common/Models/Contacts/PhoneNumber";
import { Guid } from "@/Common/Models/Guid";

class ClinicalWaitingListItem {
    public Comments: string;
    public Priority: number;
    public PatientPhoneNumbers: PhoneNumber[];
    public PatientNameAndIdentifiers: string;
    public PatientFirstName: string;
    public PatientPreferredName: string;
    public PatientLastName: string;
    public PatientId: string;
    public PatientContactId: Guid;
    public Id: string;
    public DateAdded: Date;
    public ClinicalWaitingListId: string;

    public static FromResponse(response: ClinicalWaitingListItemResponseModel): ClinicalWaitingListItem {
        let newItem = new ClinicalWaitingListItem();
        newItem.Comments = response.Comments;
        newItem.Priority = response.Priority;
        newItem.PatientPhoneNumbers = PhoneNumber.GetPhonesByPriority(response.PhoneNumbers);
        newItem.PatientNameAndIdentifiers = response.PatientNameAndIdentifiers;
        newItem.PatientFirstName = response.PatientFirstName;
        newItem.PatientPreferredName = response.PatientPreferredName;
        newItem.PatientLastName = response.PatientLastName;
        newItem.PatientId = response.PatientId;
        newItem.PatientContactId = response.PatientContactId;
        newItem.Id = response.Id;
        newItem.DateAdded = response.DateAdded;
        newItem.ClinicalWaitingListId = response.ClinicalWaitingListId;

        return newItem;
    }
}

class ClinicalWaitingListItemResponseModel {
    public Comments: string;
    public Priority: number;
    public PhoneNumbers: MyleModelsCommonResponsePhoneNumber[];
    public PatientNameAndIdentifiers: string;
    public PatientFirstName: string;
    public PatientPreferredName: string;
    public PatientLastName: string;
    public PatientId: string;
    public PatientContactId: Guid;
    public Id: string;
    public DateAdded: Date;
    public ClinicalWaitingListId: string;
}

export { ClinicalWaitingListItem };
